"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FcmTargetTab = exports.FcmTopic = exports.DocId = exports.CollectionId = void 0;
var CollectionId;
(function (CollectionId) {
    CollectionId["MobilePosts"] = "mobile:posts";
    CollectionId["MobilePostsUpvotes"] = "upvotes";
    CollectionId["MobilePostsShares"] = "shares";
    CollectionId["MobileSenders"] = "mobile:senders";
    CollectionId["MobileSurveys"] = "mobile:surveys";
    CollectionId["MobileSurveysResponses"] = "responses";
    CollectionId["MobileUsers"] = "mobile:users";
    CollectionId["MobileConfigs"] = "mobile:configs";
    CollectionId["MobileEvents"] = "mobile:events";
    CollectionId["MobileTips"] = "mobile:tips";
    CollectionId["SheetsSchemas"] = "sheets:schemas";
    CollectionId["SheetsSheets"] = "sheets:sheets";
    CollectionId["SheetsFormSubmissions"] = "sheets:form-submissions";
    CollectionId["SheetsFailedFormSubmissions"] = "sheets:failed-form-submissions";
    CollectionId["SheetsCounters"] = "sheets:counters";
    CollectionId["SheetsCountersShards"] = "shards";
    CollectionId["Admin"] = "admin";
    CollectionId["AdminUserConfigs"] = "admin:user-configs";
    CollectionId["Jobs"] = "jobs";
})(CollectionId = exports.CollectionId || (exports.CollectionId = {}));
var DocId;
(function (DocId) {
    DocId["AdminApiVersions"] = "api-versions";
    DocId["Social"] = "social";
})(DocId = exports.DocId || (exports.DocId = {}));
var FcmTopic;
(function (FcmTopic) {
    FcmTopic["General"] = "general";
    FcmTopic["Test"] = "test";
})(FcmTopic = exports.FcmTopic || (exports.FcmTopic = {}));
var FcmTargetTab;
(function (FcmTargetTab) {
    FcmTargetTab["Post"] = "post";
    FcmTargetTab["Survey"] = "survey";
    FcmTargetTab["Event"] = "event";
})(FcmTargetTab = exports.FcmTargetTab || (exports.FcmTargetTab = {}));
//# sourceMappingURL=firestore.js.map